/**
 * orga-app-api - einlasskontrolle-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProtokollEntity { 
    id?: number;
    timestampUtc?: Date;
    mandantId?: string;
    checkType?: string;
    checkResult?: number;
    vorname?: string;
    nachname?: string;
    geburtstag?: string;
    refDatum1Utc?: Date;
    refDatum2Utc?: Date;
    userId?: string;
    entityType?: string;
    version?: number;
}

